<!-- Modérateur -->
<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head mdbWavesEffect [indicator]="false" [routerLink]="PATHS.MIDDLE_TRANSPORTER_STATISTICS.path" routerLinkActive="active-link">
    <jhi-bary-icon icon="chart-line" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
    <span jhiTranslate="sidebar.moderator.stat">Statistiques</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>

<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head mdbWavesEffect [indicator]="false" [routerLink]="PATHS.MIDDLE_CUSTOMERS.path" routerLinkActive="active-link">
    <jhi-bary-icon icon="user" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
    <span data-id-cypress="sidebar-client" jhiTranslate="sidebar.moderator.client">Client</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>

<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head mdbWavesEffect [indicator]="false" [routerLink]="PATHS.MIDDLE_TRANSPORTS.path" routerLinkActive="active-link">
    <jhi-bary-icon icon="truck" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
    <span data-id-cypress="sidebar-transports" jhiTranslate="sidebar.moderator.transports">Transports</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>

<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head mdbWavesEffect [indicator]="false" [routerLink]="PATHS.MIDDLE_QUOTATIONS.path" routerLinkActive="active-link">
    <jhi-bary-icon icon="file-circle-question" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
    <span data-id-cypress="sidebar-quotations" jhiTranslate="sidebar.moderator.quotations">Quotations</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>

<mdb-accordion-item class="no-collapse">
  <mdb-accordion-item-head mdbWavesEffect [indicator]="false" [routerLink]="PATHS.MIDDLE_BILLS.path" routerLinkActive="active-link">
    <jhi-bary-icon icon="receipt" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
    <span data-id-cypress="sidebar-bills" jhiTranslate="sidebar.moderator.bills">Bills</span>
  </mdb-accordion-item-head>
</mdb-accordion-item>
<mdb-accordion-item>
  <mdb-accordion-item-head mdbWavesEffect>
    <jhi-bary-icon icon="cogs" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
    <span class="h6" jhiTranslate="sidebar.moderator.settings">Settings</span>
  </mdb-accordion-item-head>
  <mdb-accordion-item-body>
    <ul>
      <li>
        <a class="font-weight-bold" mdbWavesEffect [routerLink]="PATHS.MIDDLE_OFFERS.path" routerLinkActive="active-link">
          <jhi-bary-icon icon="euro-sign" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
          <span jhiTranslate="SIDEBAR.MODERATOR.OFFERS">Offers</span>
        </a>
      </li>
      <li>
        <a class="font-weight-bold" mdbWavesEffect [routerLink]="PATHS.MIDDLE_TRANSPORT_PLAN_ACCEPTANCE.path" routerLinkActive="active-link">
          <jhi-bary-icon icon="map-signs" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
          <span jhiTranslate="SIDEBAR.MODERATOR.TRANSPORT_PLAN">Transport plan</span>
        </a>
      </li>
      <li>
        <a class="font-weight-bold" mdbWavesEffect [routerLink]="PATHS.MIDDLE_VEHICLES.path" routerLinkActive="active-link">
          <jhi-bary-icon icon="truck" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
          <span jhiTranslate="SIDEBAR.MODERATOR.VEHICLES"></span>
        </a>
      </li>
      <li>
        <a class="font-weight-bold" mdbWavesEffect [routerLink]="PATHS.MIDDLE_MERCHANDISES.path" routerLinkActive="active-link">
          <jhi-bary-icon icon="truck-loading" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
          <span jhiTranslate="SIDEBAR.MODERATOR.MERCHANDISES">Merchandises</span>
        </a>
      </li>
    </ul>
  </mdb-accordion-item-body>
</mdb-accordion-item>

<mdb-accordion-item>
  <mdb-accordion-item-head mdbWavesEffect>
    <jhi-bary-icon icon="user-cog" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
    <span data-id-cypress="sidebar-account" class="h6" jhiTranslate="sidebar.moderator.account">Account</span>
  </mdb-accordion-item-head>
  <mdb-accordion-item-body>
    <ul>
      <li>
        <a class="font-weight-bold" mdbWavesEffect [routerLink]="PATHS.MIDDLE_TRANSPORTER.path" routerLinkActive="active-link">
          <jhi-bary-icon icon="building" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
          <span jhiTranslate="sidebar.moderator.company" data-id-cypress="sidebar-company">Company</span>
        </a>
      </li>
      <li>
        <a class="font-weight-bold" mdbWavesEffect [routerLink]="PATHS.MIDDLE_INSURANCE.path" routerLinkActive="active-link">
          <jhi-bary-icon icon="umbrella" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
          <span data-id-cypress="span-insurance" jhiTranslate="sidebar.moderator.insurance">Insurance</span>
        </a>
      </li>
      <li>
        <a class="font-weight-bold" mdbWavesEffect [routerLink]="PATHS.MIDDLE_COMMERCIALS.path" routerLinkActive="active-link">
          <jhi-bary-icon icon="briefcase" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
          <span jhiTranslate="sidebar.moderator.transporterMember">Commercials</span>
        </a>
      </li>
      <li>
        <a class="font-weight-bold" mdbWavesEffect [routerLink]="PATHS.MIDDLE_TRANSPORTER_MAILS.path" routerLinkActive="active-link">
          <jhi-bary-icon icon="envelope" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
          <span jhiTranslate="sidebar.moderator.notificationEmail">Notification emails</span>
        </a>
      </li>
      <li>
        <a class="font-weight-bold" mdbWavesEffect [routerLink]="PATHS.MIDDLE_HOMEPAGE.path" routerLinkActive="active-link">
          <jhi-bary-icon icon="pen" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
          <span data-id-cypress="span-homepage" jhiTranslate="sidebar.moderator.homepage">Configuration Page d'accueil</span>
        </a>
      </li>
    </ul>
  </mdb-accordion-item-body>
</mdb-accordion-item>

<mdb-accordion-item>
  <mdb-accordion-item-head mdbWavesEffect>
    <jhi-bary-icon icon="right-left" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
    <span data-id-cypress="sidebar-orderTracking" class="h6" jhiTranslate="sidebar.moderator.orderTracking"></span>
  </mdb-accordion-item-head>
  <mdb-accordion-item-body>
    <ul>
      <li>
        <a
          class="font-weight-bold"
          mdbWavesEffect
          [routerLink]="PATHS.MIDDLE_UNVALIDATED_BASKETS.path"
          [queryParams]="{ sort: 'creationDate,desc' }"
          routerLinkActive="active-link"
        >
          <jhi-bary-icon icon="right-left" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
          <span jhiTranslate="sidebar.moderator.unvalidatedBaskets" data-id-cypress="sidebar-transportPending"></span>
        </a>
      </li>
    </ul>
  </mdb-accordion-item-body>
</mdb-accordion-item>

<ng-container *ngIf="showDirectionalCodeNavItem">
  <mdb-accordion-item class="no-collapse">
    <mdb-accordion-item-head mdbWavesEffect [indicator]="false" [routerLink]="PATHS.MIDDLE_UPLOAD_DIRECTIONAL_CODE.path" routerLinkActive="active-link">
      <jhi-bary-icon icon="sync" [faDirective]="FAS" class="fa-fw"></jhi-bary-icon>
      <span jhiTranslate="sidebar.moderator.directionalCode">Directional code</span>
    </mdb-accordion-item-head>
  </mdb-accordion-item>
</ng-container>
